import { createFileRoute } from '@tanstack/react-router';
import { PracticeEditor } from '@/components/practice/PracticeEditor.tsx';

export const Route = createFileRoute('/_app/practice/new')({
  component: NewPracticePage,
});

/** Writing a practice conversation for the whole organisation, from scratch. */
function NewPracticePage() {
  return <PracticeEditor roleplayId={null} />;
}
